import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[#e6f0fa]/90 to-[#ffffff]/90 backdrop-blur-sm text-[#475569] py-10 px-4 sm:px-6 lg:px-8 border-t border-[#e0e7ff]/50">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto text-center"
      >
        <p className="text-[#475569]">
          主辦單位：APCS 模擬測驗團隊<br />
          贊助：<a href="https://sponsor.ncse.tw/" target="_blank" rel="noopener noreferrer" className="font-medium text-[#3b82f6] hover:underline">NCSE Network</a>、<a href="https://icebergcollege.com/" target="_blank" rel="noopener noreferrer" className="font-medium text-[#3b82f6] hover:underline">冰山程式教育學院</a>
        </p>
        <motion.a
          href="https://discord.gg/RnhATqeMtd"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 bg-gradient-to-r from-[#60a5fa] to-[#93c5fd] bg-clip-text text-transparent hover:underline inline-block"
          initial={{ scale: 0.95 }}
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
        >
          © 2026 APCS 模擬測驗團隊
        </motion.a>
      </motion.div>
    </footer>
  );
};

export default Footer;
